import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-149">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/50 z-50" onClick={onClose} data-id="element-150" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-white rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-151">
            <div className="flex items-center justify-between px-5 py-4 md:px-8 md:py-5 border-b border-charcoal/10" data-id="element-152">
              <h2 className="font-serif text-xl md:text-2xl font-bold text-charcoal" data-id="element-153">
                {title}
              </h2>
              <button onClick={onClose} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-charcoal/5 transition-colors text-charcoal/60 hover:text-charcoal" data-id="element-154">
                <XIcon size={20} data-id="element-155" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-5 py-5 md:px-8 md:py-6 text-charcoal-light text-sm md:text-base leading-relaxed space-y-4" data-id="element-156">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}